import isPlainObject from 'lodash/isPlainObject';
import isString from 'lodash/isString';
import {
  FieldErrors,
  Path,
  UseFormClearErrors,
  UseFormSetError,
} from 'react-hook-form';

import { CreateAtiraLinkDto } from '../../../model/atira-link/dto/CreateAtiraLinkDto';
import { EditAtiraLinkDto } from '../../../model/atira-link/dto/EditAtiraLinkDto';

const getFieldError = (
  index: number,
  errors?: FieldErrors<CreateAtiraLinkDto | EditAtiraLinkDto>,
): { path: string; message: string } | null => {
  const socialError = errors?.socials?.[index];

  if (!socialError) {
    return null;
  }

  let result: { path: string; message: string } | null = null;

  const traverse = (node: any, path: string) => {
    if (result) {
      return;
    }

    if (Array.isArray(node)) {
      node.forEach((item, i) => traverse(item, `${path}.${i}`));
    } else if (isPlainObject(node)) {
      for (const key in node) {
        const value = node[key];

        if (key === 'message' && isString(value)) {
          result = {
            path,
            message: value,
          };
          return;
        }

        traverse(value, `${path}.${key}`);
        if (result) {
          return;
        }
      }
    }
  };

  traverse(socialError, `socials.${index}`);
  return result;
};

export function moveErrorMessage<T extends Record<string, any>>(
  activeIndex: number,
  overIndex: number,
  setError: UseFormSetError<T>,
  clearErrors: UseFormClearErrors<T>,
  formErrors: FieldErrors<CreateAtiraLinkDto | EditAtiraLinkDto>,
) {
  const activeItemError = getFieldError(activeIndex, formErrors);
  const overItemError = getFieldError(overIndex, formErrors);

  if (activeItemError?.message && activeItemError?.path) {
    setError(
      activeItemError.path.replace(
        /socials\.(\d+)/,
        `socials.${overIndex}`,
      ) as Path<T>,
      {
        message: activeItemError.message,
      },
    );

    clearErrors(`socials.${activeIndex}` as Path<T>);
  } else if (overItemError?.message && overItemError?.path) {
    setError(
      overItemError.path.replace(
        /socials\.(\d+)/,
        `socials.${activeIndex}`,
      ) as Path<T>,
      {
        message: overItemError.message,
      },
    );

    clearErrors(`socials.${overIndex}` as Path<T>);
  }
}
